export default __webpack_public_path__ + "images/signup_users.a9eb0115b79ef5a32882e1103c59077b.png";